import React, { useRef } from 'react';
import 'react-sliding-pane/dist/react-sliding-pane.css';

import { Icon } from 'coreOld/elements';
import { Position } from 'coreOld/enums';
import { useCloseMenuIfClickedOutside } from 'coreOld/hooks';

import { IconWrapper, SlidingPaneStyled } from './slidingPanelStyle';

const DEFAULT_PANEL_WIDTH = '60%';

interface IProps {
  isOpen: boolean;
  onClosePanel: () => void;
  children?: React.ReactNode | React.ReactNode[];
  openFrom?: 'left' | 'bottom' | 'right';
  width?: string;
}

const SlidingPanelView = ({
  isOpen,
  onClosePanel,
  children,
  openFrom,
  width = DEFAULT_PANEL_WIDTH,
}: IProps) => {
  const ref = useRef(null);

  useCloseMenuIfClickedOutside(ref, isOpen, () => onClosePanel());

  return (
    <SlidingPaneStyled
      className="slide-custom-wrapper"
      closeIcon={<Icon name={Icon.CLOSE} />}
      isOpen={isOpen}
      from={openFrom || Position.RIGHT}
      width={width}
      onRequestClose={onClosePanel}
    >
      <IconWrapper onClick={onClosePanel}>
        <Icon name={Icon.CLOSE} />
      </IconWrapper>

      {children}
    </SlidingPaneStyled>
  );
};

export default SlidingPanelView;
